<template>
  <div class="v-form-field">
    <!-- label -->
    <label v-if="(fieldData.type !== 'hidden' && fieldData.type !== 'heading' && fieldData.type !== 'bool')" :for="generatedId" class="v-form-field__label">{{fieldData.label}}</label>
    <label v-if="fieldData.type == 'bool'" class="v-form-field__label">{{fieldData.label}}</label>
    <div v-if="fieldData.help" v-html="span(fieldData.help)" />

    <!-- errors -->
    <p class="v-form-field__errors" v-if="errorMessages.length">
      <span v-for="(message, index) in errorMessages" v-bind:key="index">{{message}}<br></span>
    </p>

    <!-- input type text -->
    <input v-if="fieldData.type === 'text'" class="v-form-field__text" :id="generatedId" v-model="fieldData.value" type="text" :placeholder="fieldData.placeholder" v-on:blur="onFieldBlur" v-on:input="updateFormData" v-on:keydown.enter.prevent>
    <!-- input type textarea -->
    <textarea v-if="fieldData.type === 'textarea'" class="v-form-field__text" :id="generatedId" v-model="fieldData.value" v-on:input="updateFormData" :placeholder="fieldData.placeholder"></textarea>
    <!-- datepicker -->
    <datepicker v-if="fieldData.type === 'date'" :language="language" :format="'dd.MM.yyyy'" :clear-button="true" class="v-form-field__date" :id="generatedId" v-model="fieldData.value" @input="updateFormData"></datepicker>

    <input v-if="fieldData.type === 'email'" class="v-form-field__email" :id="generatedId" v-model="fieldData.value" type="email" v-on:input="updateFormData">
    <v-pass-strength v-if="fieldData.type === 'password-strength'" :password="fieldValue">
      <input autocomplete="new-password" class="v-form-field__password v-pass-strength__password-field" :id="generatedId" v-model="fieldData.value" type="password" v-on:input="updateFormData">
    </v-pass-strength>
    <input v-if="fieldData.type === 'password'" autocomplete="new-password" class="v-form-field__password" :id="generatedId" v-model="fieldData.value" type="password" v-on:input="updateFormData">
    <!-- input type hidden -->
    <input v-if="fieldData.type === 'hidden'" type="hidden" v-model="fieldData.value">
    <!-- input type select (custom style)-->
    <div v-if="fieldData.type == 'select'" class="custom-select custom-select-full-width js-custom-select-wrapper">
      <div class="custom-select__dropdown custom-select__dropdown--full-width js-custom-select-dropdown"></div>
      <span :id="generatedId" class="custom-select__text js-custom-select-textholder">{{selectedOptionText}}</span>
      <select :id="generatedId" v-model="fieldData.value" v-on:change="updateFormData" class="form__field-select js-custom-select form__field-select-custom form__field-select-custom-full-width js-lang-select lang_select">
        <option disabled value="">{{loc('forms.select.defaultEmpty')}}</option>
            <option v-for="option in fieldData.options"  selected="key == option.text" v-bind:value="option.value" v-bind:key="option.text" v-bind:text="option.text">
          {{ option.text }}
        </option>
      </select>
    </div>

    <!-- section header -->
    <div v-if="fieldData.type == 'heading'" class="v-form__section-heading">
      <h3>{{fieldData.heading}}</h3>
    </div>

    <!-- radio button -->
    <div v-if="fieldData.type == 'bool'" class="v-form-field__radio">
      <label class="checkbox-inline"><input type="radio" :id="generatedId" :name="generatedId" v-model="fieldData.value" v-on:change="updateFormData" value="1"> {{loc('forms.radio.yes')}} </label>
      <label class="checkbox-inline"><input type="radio" :id="generatedId" :name="generatedId" v-model="fieldData.value" v-on:change="updateFormData" value="0"> {{loc('forms.radio.no')}} </label>
    </div>

    <v-data-items v-if="fieldData.type === 'data-items'" :hide-empty="fieldData.hideEmpty"  :sum-field="fieldData.sumField" :multiply-field="fieldData.multiplyField" :fields="fieldData.fields" :data="fieldData.value" :errors="errorItems" :add-btn-text="fieldData.addBtnText"></v-data-items>
    <!-- input type select (default style) -->
    <!--<select v-if="fieldData.type === 'select'" :id="generatedId" v-model="fieldData.value" v-on:change="updateFormData">
      <option disabled value="">{{loc('forms.select.defaultEmpty')}}</option>
      <option v-for="option in fieldData.options" v-bind:value="option.value" v-bind:key="option.value">
        {{ option.text }}
      </option>
    </select>-->
    <!-- input type file -->
    <v-file v-if="fieldData.type === 'file'" :file-count-limit="fieldData.fileCountLimit" :multiple="!!fieldData.multiple" :on-change="onFieldChange"></v-file>
  </div>
</template>

<script>

import VPassStrength from './v-pass-strength.vue';
import VFile from './v-file.vue';
import datepicker from 'vuejs-datepicker';
import VDataItems from './v-data-items.vue';

function guidGenerator() {
  var S4 = function() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };

  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
export default {
  components: {
    'v-pass-strength': VPassStrength,
    'datepicker': datepicker,
    'v-file': VFile,
    'v-data-items': VDataItems
  },
  props: ['field-data', 'formData', 'formErrors', 'on-change', 'on-blur'],
  data: function () {
    return {
      generatedId: guidGenerator(),
      fieldValue: ''
    }
  },
  methods: {
    span(text) {
      return `<span>${text}</span>`
    },
    updateFormData() {
      this.formData[this.fieldData.name] = this.fieldData.value;
      this.fieldValue = this.fieldData.value;
      // Trigger onChange callback if any
      if(typeof this.onChange === 'function') {
        this.onChange(this.formData);
      }
    },
    onFieldBlur() {
      if (typeof this.onBlur === 'function') {
        this.onBlur(this.fieldData);
      }
    },
    onFieldChange(data) {
      this.fieldData.value = data;
      this.updateFormData();
    }
  },
  computed: {
    language() {
      return this.$store.state.language;
    },
    errorMessages() {
      const error = this.formErrors[this.fieldData.name];

      return error && error.messages || [];
    },
    errorItems() {
      const error = this.formErrors[this.fieldData.name];

      return error && error.items || null;
    },
    passwordFieldValue() {
      return this.fieldData.type === 'password' && this.fieldValue || '';
    },
    selectedOptionText()  {

      for(var i = 0 ; i < this.fieldData.options.length ; i++){
        if(this.fieldValue == this.fieldData.options[i].value){
          return this.fieldData.options[i].text;
        }
      }
      return "";
    }
  },
  mounted: function () {
    this.updateFormData();
  },
  watch: {
    // Update formData when passed field data change
    fieldData() {
      this.updateFormData();
    }
  }
}
</script>

<style>

</style>
